import React, { useState, useEffect } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const StepHumanCapital = ({ data = {}, onSubmit, onBack, saving }) => {
  const [use_of_staffing_agencies, setUseOfStaffingAgencies] = useState(false);
  const [direct_severance_pay_management, setDirectSeverancePayManagement] = useState(false);
  const [use_of_tfm_policies, setUseOfTfmPolicies] = useState(false);
  const [use_of_kman_policies, setUseOfKmanPolicies] = useState(false);
  const [corporate_welfare, setCorporateWelfare] = useState(false);
  const [health_welfare, setHealthWelfare] = useState(false);

  useEffect(() => {
    setUseOfStaffingAgencies(!!data.use_of_staffing_agencies);
    setDirectSeverancePayManagement(!!data.direct_severance_pay_management);
    setUseOfTfmPolicies(!!data.use_of_tfm_policies);
    setUseOfKmanPolicies(!!data.use_of_kman_policies);
    setCorporateWelfare(!!data.corporate_welfare);
    setHealthWelfare(!!data.health_welfare);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      use_of_staffing_agencies,
      direct_severance_pay_management,
      use_of_tfm_policies,
      use_of_kman_policies,
      corporate_welfare,
      health_welfare,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep6Title") || "Capitale Umano"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep6Description") ||
            "Inserisci i dati relativi al personale impiegato nella tua azienda, suddiviso per ruoli, competenze e aree operative."}
        </p>
      </div>
      <div className="p-fluid grid" style={{ rowGap: "1rem" }}>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="use_of_staffing_agencies"
            checked={use_of_staffing_agencies}
            onChange={(e) => setUseOfStaffingAgencies(e.checked)}
          />
          <label htmlFor="use_of_staffing_agencies">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6StaffingAgenciesLabel") ||
                "Utilizzo di Agenzie per il Lavoro"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6StaffingAgenciesHelp") ||
                "Indica se l'azienda utilizza agenzie esterne per la selezione e gestione del personale."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="direct_severance_pay_management"
            checked={direct_severance_pay_management}
            onChange={(e) => setDirectSeverancePayManagement(e.checked)}
          />
          <label htmlFor="direct_severance_pay_management">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6DirectSeveranceLabel") ||
                "Gestione diretta del TFR"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6DirectSeveranceHelp") ||
                "Segnala se l'azienda gestisce internamente il Trattamento di Fine Rapporto dei dipendenti."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="use_of_tfm_policies"
            checked={use_of_tfm_policies}
            onChange={(e) => setUseOfTfmPolicies(e.checked)}
          />
          <label htmlFor="use_of_tfm_policies">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6UseTfmLabel") || "Utilizzo di polizze TFM"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6UseTfmHelp") ||
                "Specifica se l'azienda utilizza polizze TFM (Trattamento di Fine Mandato) per gli amministratori."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="use_of_kman_policies"
            checked={use_of_kman_policies}
            onChange={(e) => setUseOfKmanPolicies(e.checked)}
          />
          <label htmlFor="use_of_kman_policies">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6UseKmanLabel") || "Utilizzo di polizze KMAN"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6UseKmanHelp") ||
                "Indica se sono attive polizze assicurative KMAN per figure chiave dell'azienda."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="corporate_welfare"
            checked={corporate_welfare}
            onChange={(e) => setCorporateWelfare(e.checked)}
          />
          <label htmlFor="corporate_welfare">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6CorporateWelfareLabel") || "Welfare Aziendale"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6CorporateWelfareHelp") ||
                "Indica se l'azienda offre un piano di welfare aziendale (benefici e servizi per i dipendenti)."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex align-items-start gap-2">
          <Checkbox
            inputId="health_welfare"
            checked={health_welfare}
            onChange={(e) => setHealthWelfare(e.checked)}
          />
          <label htmlFor="health_welfare">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep6HealthWelfareLabel") || "Welfare Sanitario"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep6HealthWelfareHelp") ||
                "Segnala se l'azienda offre polizze o servizi di welfare sanitario ai dipendenti."}
            </div>
          </label>
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2 justify-content-end">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            style={{ color: "var(--theme-primary)" }}
            onClick={onBack}
            disabled={saving}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepHumanCapital;
